import validator from 'validator'

class FormValidator {
	/**
	 * Default constructor
	 * @param {Array} validations - an array of rules for the current component
	 * @returns {void} - no return value
	 * @public
	 */
	constructor(validations) {
		// validations is an array of rules specific to a form
		this.validations = validations
	}

	/**
	 * Performs validation of the component
	 * @param {state} state - the current state of the component
	 * @returns {validation} - the current list of errors in the coponent
	 * @public
	 */
	async validate(state, props) {
		// start out assuming valid
		let validation = this.valid()

		// for each validation rule
		await Promise.all(this.validations.map(async rule => {
			// if the field isn't already marked invalid by an earlier rule
			if (!validation[rule.field].isInvalid && !rule.isDisabled) {
				// determine the field value, the method to invoke and
				// optional args from the rule definition
				let field_value = !rule.prop ? state[rule.field] : rule.prop.object ? props[rule.prop.object][rule.prop.name] : props[rule.prop.name]

				field_value = field_value === undefined ? '' : field_value
				field_value = field_value === null ? '' : field_value

				const args = rule.args || []
				const validation_method = typeof rule.method === 'string' ?
					validator[rule.method] :
					rule.method

				// call the validation_method with the current field value
				// as the first argument, any additional arguments, and the
				// whole state as a final argument.  If the result doesn't
				// match the rule.validWhen property, then modify the
				// validation object for the field and set the isValid
				// field to false
				const validation_result = await validation_method(field_value.toString(), ...args, state, props)

				if (validation_result !== rule.validWhen) {
					validation[rule.field] = {
						isInvalid: true,
						message: rule.message
					}
					validation.isValid = false
				}
			}
		}))

		return validation
	}

	/**
	 * Create a validation object for a valid form
	 * @returns {validation} - a validation object with no errors
	 * @public
	 */
	valid() {
		const validation = {}

		this.validations.map(rule => (
			validation[rule.field] = { isInvalid: false, message: '' }
		))

		return { isValid: true, ...validation }
	}
}

export default FormValidator


// WEBPACK FOOTER //
// ./src/components/FormValidator.js